import { useState } from "react";
import PropTypes from "prop-types";

import Modal from "@shared/v2/Modal";
import { ArrowLeftSolidV6 } from "@shared/v2/Icomoon";
import Button from "@shared/v2/Button";
import InvalidAddressModalBody from "./InvalidAddressModalBody";

const InvalidAddressModal = ({ address, onClose, onEdit, onSubmit, show }) => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Modal
      className="tw-flex tw-items-center tw-justify-center"
      show={show}
      onHide={onClose}
      contentClassName="tw-w-[616px] tw-flex tw-flex-col tw-gap-24px"
    >
      <Modal.Header
        title="Potentially Invalid Address"
        closeButton
      />
      <Modal.Body className="tw-flex tw-flex-col tw-gap-[24px] tw-p-8px tw-text-14d tw-text-gray-75">
        <InvalidAddressModalBody
          streetAddress={address?.streetAddress}
          secondaryAddress={address?.secondaryAddress}
          city={address?.city}
          locality={address?.locality}
          postalCode={address?.postalCode}
          country={address?.country}
        />
      </Modal.Body>
      <Modal.Footer className="tw-flex tw-justify-between">
        <Button className='tw-flex tw-gap-6px tw-justify-center tw-items-center' schema="tertiary" size="medium" onClick={() => {
          onEdit();
          onClose();
        }}>
          <ArrowLeftSolidV6 />
          <span>Edit</span>
        </Button>
        <Button
          schema="primary" size="medium"
          isLoading={isLoading}
          onClick={async () => {
            setIsLoading(true)
            await onSubmit();
            setIsLoading(false);
            onClose();
          }}
        >
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  )
};

export default InvalidAddressModal;

InvalidAddressModal.propTypes = {
  address: PropTypes.shape({
    streetAddress: PropTypes.string,
    secondaryAddress: PropTypes.string,
    city: PropTypes.string,
    locality: PropTypes.string,
    postalCode: PropTypes.string,
    country: PropTypes.string
  }),
  onClose: PropTypes.func,
  onEdit: PropTypes.func,
  onSubmit: PropTypes.func,
  show: PropTypes.bool
};

InvalidAddressModal.defaultProps = {
  show: false,
  address: null,
  onClose: () => { },
  onEdit: () => { },
  onSubmit: () => { }
};